<template>
<el-popover ref="eventPopover" popper-class="event-popover" placement="bottom" width="400" trigger="click" @show="onEventPopoverShow" @hide="onEventPopoverHide">
  <!-- reference -->
  <el-badge slot="reference" ref="eventBadge" class="tool-icon event-badge c-pointer" :hidden="eventTotalCount <= 0" :value="eventTotalCount" :max="99">
    <el-tooltip content="실시간 이벤트" placement="bottom">
      <!-- <a><i class="fas fa-bell r-top"></i></a> -->
      <i class="fas fa-bell r-top"></i>
    </el-tooltip>
  </el-badge>
  <!-- <span slot="reference"><slot name="button"></slot></span> -->
  <!-- popover -->
  <div class="content" v-loading="listLoading">
    <el-scrollbar class="bar-visible">
      <ul class="event-notice">
        <li v-for="(item, index) in eventDatas" :key="index">
          <span class="icon-dot" :style="{ backgroundColor: item.eventlevelColorBg }"></span>
          <span class="text-area">
              <div class="desc">
                {{ item.objName }}
              </div>
              <div>
                <div v-if="item.dynamicThresholdFlag === 'Y'" class="round-box-info-text red">
                  동적
                </div>
                <div class="c-pointer" @click="onClickEventRow(item)">{{item.eventMessage }}</div>
              </div>
              <span class="date">{{ convertDatetime(item.checkDatetime) }}</span>
          </span>
        </li>
      </ul>
    </el-scrollbar>
  </div>
  <el-row class="footer" type="flex" justify="space-between">
    <el-checkbox-group v-model="checkedEventlevelIds" @change="onChangeEventId">
      <el-checkbox style="min-width:52px;" v-for="item in eventCountDatas" :key="item.eventlevelId" :label="item.eventlevelId">
        <div class="label">
          <div :class="$style['event-level-dot']" :style="{ backgroundColor: item.eventlevelColorBg }"></div>
          {{ item.cnt }}
        </div>
      </el-checkbox>
    </el-checkbox-group>
    <!-- <el-button type="solid" @click="onClickClearStore"> 초기화 </el-button> -->
  </el-row>
</el-popover>
</template>

<script>
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import eventAPI from '@/api/frame/event';
import { openFaultAnalysisPopup } from '@/utils/event';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { mapGetters } from 'vuex';

export default {
  name: 'WEventPopover',
  data() {
    return {
      listLoading: false,
      countLoaing: false,
      checkedEventlevelIds: [],
      eventDatas: [],
      eventCountDatas: [],
      currentHighEventlevel: null,
      eventTotalCount: 0,
      eventStatusCountTask: 'eventStatusCountTask',
    };
  },
  computed: mapGetters(['selectedNode']),
  created() {
    this.loadEventStatusCount(true);
    this.$taskManager.createTask(this.eventStatusCountTask, 30, this.loadEventStatusCount, true);
    this.$taskManager.startTask(this.eventStatusCountTask);
  },
  beforeDestroy() {
    this.$taskManager.removeTask(this.eventStatusCountTask);
  },
  methods: {
    loadEventStatus() {
      this.listLoading = true;
      eventAPI.getEventStatusOfPhysical({ eventIdList: this.checkedEventlevelIds }).then((response) => {
        if (response.data.success) {
          this.eventDatas = response.data.data;
        }
      }).finally(() => {
        this.listLoading = false;
      });
    },
    loadEventStatusCount(setEventlevelCheckboxFlag) {
      if (this.countLoaing) { // 이전 요청이 완료되지 않은 경우 요청을 보내지 않는다.
        return;
      }
      this.countLoaing = true;
      eventAPI.getEventStatusCountOfPhysical().then((response) => {
        if (response.data.success) {
          this.eventCountDatas = response.data.data;
          this.setCurrentHighEventlevelAndTotalCount(this.eventCountDatas);
          if (setEventlevelCheckboxFlag) {
            const eventlevelIds = [];
            forEach(this.eventCountDatas, (item) => {
              eventlevelIds.push(item.eventlevelId);
            });
            this.checkedEventlevelIds = eventlevelIds;
          }
        }
      }).finally(() => {
        this.countLoaing = false;
      });
    },
    setCurrentHighEventlevelAndTotalCount(eventlevelCounts) {
      let highEventlevel = null;
      let total = 0;
      for (let i = 0; i < eventlevelCounts.length; i += 1) {
        if (highEventlevel === null && eventlevelCounts[i].cnt > 0) {
          highEventlevel = eventlevelCounts[i];
        }
        total += eventlevelCounts[i].cnt;
      }

      if (this.eventTotalCount !== total) {
        this.$emit('count-change', total);
      }

      this.eventTotalCount = total;
      this.currentHighEventlevel = highEventlevel;
      const badgeContentEl = isNil(this.$refs.eventBadge) ? null : this.$refs.eventBadge.$el.querySelector('.el-badge__content');
      if (!isNil(highEventlevel) && !isNil(badgeContentEl)) {
        badgeContentEl.style.backgroundColor = highEventlevel.eventlevelColorBg;
      }
    },
    /**
     * [convertDatetime 날짜 포맷 설정]
     * @author {Yang}
     */
    convertDatetime(value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    /**
     * 팝업을 열 때 이벤트 현황 데이터를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    onEventPopoverShow() {
      this.$nextTick(() => {
        this.loadEventStatusCount();
        this.loadEventStatus();
      });
    },
    onEventPopoverHide() {
      this.eventDatas = [];
    },
    /**
     * [onClickEventRow 이벤트 row 클릭]
     * @author {Yang}
     */
    onClickEventRow(row) {
      if (!isNil(row.eventSeqNumber)) {
        this.$refs.eventPopover.doClose();
        openFaultAnalysisPopup(row.eventSeqNumber);
      }
    },
    /**
     * [onChangeEventId 이벤트 체크박스 선택시 데이터 로드]
     * @author {Yang}
     */
    onChangeEventId() {
      if (this.checkedEventlevelIds.length === 0) {
        this.eventDatas = [];
      } else {
        this.loadEventStatus();
      }
    },
  },
};
</script>

<style module>
.event-level-dot {
  display: inline-block;
  height: 9px;
  width: 9px;
  position: relative;
  top: 1px;
  border-radius: 50%;
  margin-left: 2px;
}

.txt {
  display: flex;
  align-items: center;
  margin-top: 0.5px;
  color: #666;
  line-height: initial;
}
</style>

<style lang="scss">
//add 1120 ie friendly
.event-badge {
  .el-badge__content {
    font-size: 11px;
    padding: 0px 5px;
    //add 1207 ie friendly
    background-clip: padding-box;
    //end 1207
    &.is-fixed {
      top: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/EventPopover.vue